import axiosPost from "./axiosPost";

export const RNHDepartamentoDel = async (credentials, data) => {
    const body = {
        service: "RNHDepartamentoDel",
        params: {
            rnhDepartamentoId: data?.id || null,
        },
    };

    const result = await axiosPost(body, credentials);
    if(result?.status?.code === 0) {
        return [result.status]
    } else {
        return result.result;
    }
};
